<template>
  <div class="menu-lateral desktop transition_on">
    
    <div class="item-menu user">
      <div v-if="isLoading" class="user-img-skeleton"></div>
      <img
        v-else-if="user.photo_url"
        :src="user.photo_url"
        alt="Foto Usuário"
      />
      <p>
        {{ userName }}<br />
        <em>{{ userRole }}</em>
      </p>
    </div>

    <router-link to="/dashboard">
      <div class="item-menu">
        <img src="/img/icon-statistics.png" alt="Statistics" />
        <p>Statistics</p>
      </div>
    </router-link>

    <div
      class="item-menu subitens"
      v-show="isAdmin || isBasicAdmin"
      @click="toggleMenu"
    >
      <img src="/img/icon-comm.png" />
      <p>Comm</p>
      <span>></span>

      <ul>
        <router-link to="/cargas_tipos/adicionar"><li>New</li></router-link>
        <router-link to="/cargas_tipos/listar"><li>List</li></router-link>
      </ul>
    </div>

    <div class="item-menu subitens" @click="toggleMenu">
      <img src="/img/icon-lines.png" />
      <p>Line-ups</p>
      <span>></span>

      <ul>
        <router-link to="/lineups/adicionar" v-show="!isClient">
          <li>New</li>
        </router-link>
        <router-link to="/lineups/listar"><li>List</li></router-link>
      </ul>
    </div>

    <div
      class="item-menu subitens"
      v-show="isAdmin || isBasicAdmin"
      @click="toggleMenu"
    >
      <img src="/img/icon-fields.png" />
      <p>Fields of line-ups</p>
      <span>></span>

      <ul>
        <router-link to="/campos/afretadores"><li>Charterers</li></router-link>
        <router-link to="/campos/agencias"><li>Agencies</li></router-link>
        <router-link to="/campos/navios"><li>Vessels</li></router-link>
        <router-link to="/campos/recebedores"><li>Receivers|Shippers</li></router-link>
        <router-link to="/campos/lineup_porto"><li>Ports</li></router-link>
      </ul>
    </div>

    <div
      class="item-menu subitens"
      v-show="isAdmin || isBasicAdmin || isOperator"
      @click="toggleMenu"
    >
      <img src="/img/icon-ports.png" />
      <p>Ports</p>
      <span>></span>

      <ul>
        <router-link to="/portos/adicionar" v-show="isAdmin || isBasicAdmin">
          <li>New</li>
        </router-link>
        <router-link to="/portos/listar"><li>List</li></router-link>
      </ul>
    </div>

    <div
      class="item-menu subitens"
      v-show="isAdmin"
      @click="toggleMenu"
    >
      <img src="/img/icon-grups.png" />
      <p>Users</p>
      <span>></span>

      <ul>
        <router-link to="/usuarios/adicionar"><li>New</li></router-link>
        <router-link to="/usuarios/listar"><li>List</li></router-link>
        <router-link to="/usuarios/atividades"><li>Activities</li></router-link>
      </ul>
    </div>

    <div class="item-menu subitens" v-show="isAdmin" @click="toggleMenu">
      <img src="/img/icon-prospects.svg" />
      <p>Prospects</p>
      <span>></span>

      <ul>
        <router-link to="/prospects/adicionar"><li>New</li></router-link>
        <router-link to="/prospects/listar"><li>List</li></router-link>
      </ul>
    </div>

    <router-link
      to="/exportation-logs"
      class="item-menu subitens"
      v-show="isAdmin"
    >
      <img src="/img/icon-lines.png" />
      <p>Exportation logs</p>
    </router-link>

    <router-link
      class="item-menu subitens"
      to="/email_information"
      v-show="isAdmin || isBasicAdmin"
    >
      <img src="/img/icon-comm.png" />
      <p>Email Information</p>
    </router-link>

  </div>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.getters["profile/me"] || null;
    },

    isLoading() {
      return !this.user;
    },

    isAdmin() {
      return this.$root.isAdmin ?? false;
    },

    isBasicAdmin() {
      return this.$root.isBasicAdmin ?? false;
    },

    isOperator() {
      return this.$root.isOperator ?? false;
    },

    isClient() {
      return this.$root.isClient ?? false;
    },

    user() {
      return this.$store.getters["profile/me"] || null;
    },

    userName() {
      return this.user && this.user.name ? this.user.name : 'Loading...';
    },

    userRole() {
      return this.user && this.user.role ? this.user.role : '';
    }
  },

  methods: {
    toggleMenu(event) {
      let menu = event.target;
      const menus = document.querySelectorAll(".item-menu.subitens");

      while (!menu.classList.contains("subitens")) {
        menu = menu.parentNode;
      }

      menus.forEach((m) => m.classList.remove("ativo"));
      menu.classList.add("ativo");
    }
  }
}
</script>

<style>

.user-img-skeleton {
  width: 85px;
  height: 85px;
  margin-bottom: 5px;
  border-radius: 100%;
  background: linear-gradient(
    90deg,
    #3f3f3f 25%,
    #ffffff33 50%,
    #3f3f3f 75%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>